import { WithStyles } from 'decorators/withStyles';
import * as React from 'react';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import ReportProblemIcon from 'mdi-react/ReportProblemIcon';
import IconButton from '@material-ui/core/IconButton';
import Close from 'mdi-react/CloseIcon';
import storageService from 'services/storage';
import { enAnnouncementsType, ITextAnnouncement } from 'interfaces/announcements';
import InfoCircleIcon from 'mdi-react/InfoCircleIcon';

interface IProps extends ITextAnnouncement {
  classes?: any;
  id: string;
}

interface IState {
  open: boolean;
}

const hashMap = {
  [enAnnouncementsType.INFORMATIVE]: <CheckCircleIcon size="32" className="icon-informative" />,
  [enAnnouncementsType.POSITIVE]: <InfoCircleIcon size="32" className="icon-positive" />,
  [enAnnouncementsType.NEGATIVE]: <ReportProblemIcon size="32" className="icon-negative" />,
  [enAnnouncementsType.WARNING]: <ReportProblemIcon size="32" className="icon-warning" />
};

@WithStyles(() => ({
  snackbar: {
    marginBottom: 16,
    maxWidth: 'none',
    boxShadow: 'none',
    paddingRight: '0.5rem',
    padding: '1rem',
    color: '#37474F',
    fontWeight: 500,
    borderRadius: '0.5rem',
    '& .MuiSnackbarContent-message': {
      width: '100%',
      padding: 0
    },
    '&.informative': {
      backgroundColor: '#CDEBFA'
    },
    '&.positive': {
      backgroundColor: '#D2EBD3'
    },
    '&.negative': {
      backgroundColor: '#FDD9D7'
    },
    '&.warning': {
      backgroundColor: '#FFF4D4'
    }
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    '& button': {
      paddingTop: '0'
    }
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      '&.icon-informative': {
        fill: '#039be5'
      },
      '&.icon-positive': {
        fill: '#4caf50'
      },
      '&.icon-negative': {
        fill: '#f44336'
      },
      '&.icon-warning': {
        fill: '#ffca28'
      }
    },
    '& span': {
      lineHeight: '0',
      width: 30,
      height: 30
    },
    '& button': {
      padding: 0
    }
  },
  content: {
    margin: '0 1rem 0 1rem'
  },
  title: {
    margin: '0 0 0.5rem 0',
    fontSize: '1.25rem'
  },
  closeIcon: {
    fill: '#37474F'
  },
  text: {
    margin: 0,
    '& a': {
      textDecoration: 'underline',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  }
}))
export default class TextAnnouncement extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { open: true };
  }

  componentDidMount(): void {
    storageService.get(this.props.id).subscribe(announcementByStorage => {
      this.setState({ open: !announcementByStorage });
    });
  }

  onClose = () => {
    storageService.set(this.props.id, true).subscribe();
    this.setState({ open: false });
  };

  render() {
    const { classes, text, type, title } = this.props;
    const { open } = this.state;

    if (!open) {
      return null;
    }

    return (
      <SnackbarContent
        className={`${classes.snackbar} ${type.toLowerCase()}`}
        message={
          <div className={classes.container}>
            <div className={classes.messageContainer}>
              <span>{hashMap[type]}</span>
              <div className={classes.content}>
                {title && <p className={classes.title}>{title}</p>}
                <p className={classes.text} dangerouslySetInnerHTML={{ __html: text }}></p>
              </div>
              <IconButton style={{ marginRight: '0.5rem' }} onClick={this.onClose}>
                <Close className={classes.closeIcon} />
              </IconButton>
            </div>
          </div>
        }
      />
    );
  }
}
